import type { Agent } from '@/lib/types/agents'
import apiClient from "@/lib/api/client";
import API from "@/api/API";

export const agentsApi = {
  list: async (params?: { q?: string; category?: string }) => {
    const response = await apiClient.get<Agent[]>(API.agent.list, { params })
    return response.data
  },
}

